import type { FaireProductEntity } from "../../entity_types/product";

export const p_8etn3ggv8a: FaireProductEntity = {
  token: "p_8etn3ggv8a",
  type: "product",
  name: "M7377-SW CALIFORNIA",
  brandToken: "b_7t768kwdvz",
  brandName: "HARANG",
  imageUrl:
    "https://cdn.faire.com/fastly/73e71631d8e4041c1a3cc55bf6d054da931f78bee610d92ecd14a66bf8499710.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5fed368eb685363ce7f4682aaf04c8573ba4d80a34d3ccdd11133d6733a51bd9.jpeg",
    "https://cdn.faire.com/fastly/f05171715671fa2633d44d1278a606317c1834f3197b9e87a160ed1666e92aac.jpeg",
    "https://cdn.faire.com/fastly/741977988df5f5129a2ca95423df8a0cd96f75feb9d3f99bfdead30304334b86.jpeg",
    "https://cdn.faire.com/fastly/48b8baec7e99ee3c06b5158d0dc016ea6f64f9622cc733afc1f27d1ad87f8c1e.jpeg",
  ],
  priceDollars: 24.88,
  description:
    "This unisex tee is made of very soft cotton. The double stitching on the neckline and sleeves add more durability to what is sure to be a favorite!\nFeatures: Mid-weight Fleece \nFabrication: 80% Cotton, 20% Poly Ring-Spun Yarn 7.8 oz.\nPrinted in the USA. \n-S-3XL AVAILABLE\n-Other colors are also available\n-Please write it down in the memo when you make a purchase .",
  tags: [],
  msrpDollars: 49.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:54.530Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
